import $ from 'cash-dom';
import ChatTool from './main/'
import { isElement, isFunction } from 'underscore';
import polyfills from 'utils/polyfills';

polyfills();

module.exports = (() => {
  const defaultConfig = {
    // If true renders editor on init
    autorender: 1,

    // Array of plugins to init
    plugins: [],

    // Custom options for plugins
    pluginsOpts: {}
  };

  return {
    $,

    // Will be replaced on build
    version: '<# VERSION #>',

    init(config = {}) {
      const chatTool = new ChatTool(config).init();
      chatTool.render(); 
    }
  };
})();
